import {Component, computed, Injectable, Input, signal} from '@angular/core';
import {MatCheckboxChange, MatCheckboxModule} from '@angular/material/checkbox';
import {ResourceSearchSchema} from '@middleware';
import {Filter, FilterVisibility} from '../filter';

@Component({
  template: `<ul class="bulletless">
    <li
      ><mat-checkbox value="draft" [checked]="filter.selectedValues().includes('draft')" (change)="changed($event)"
        >Owners Only</mat-checkbox
      ></li
    >
    <li
      ><mat-checkbox
        value="published"
        [checked]="filter.selectedValues().includes('published')"
        (change)="changed($event)"
        >All Users</mat-checkbox
      ></li
    >
  </ul>`,
  imports: [MatCheckboxModule],
})
class VisibilityView {
  @Input() filter: VisibilityFilter;

  changed($event: MatCheckboxChange) {
    if ($event.checked) {
      this.filter.add($event.source.value);
    } else {
      this.filter.remove($event.source.value);
    }
  }
}

@Injectable()
export class VisibilityFilter implements Filter<'Resources'> {
  key = 'visibility';
  label = 'Visibility';
  component = VisibilityView;
  selectedValues = signal<string[]>([]);
  selected = computed(() =>
    this.selectedValues().map(value => ({
      value,
      label: value == 'draft' ? 'Owners Only' : value == 'published' ? 'All Users' : value,
    })),
  );
  defaultExpanded = false;
  load(values: string[]): void {
    this.selectedValues.set(values.filter(v => v === 'draft' || v === 'published'));
  }
  apply(filterBody: ResourceSearchSchema): void {
    const values = this.selectedValues();
    if (values.length != 1) return;
    filterBody.visible_to_all_users = {
      value: values[0] === 'published',
    };
  }
  add(value: string): void {
    if (value !== 'draft' && value !== 'published') return;
    this.selectedValues.update(values => [...values, value]);
  }
  remove(value: string): void {
    this.selectedValues.update(values => values.filter(v => v != value));
  }
  visibility = FilterVisibility.ONLY_ADMIN_USERS;
}
